import React from 'react';
import {
    ITableColumn,
    renderAmount,
    ProviderPatientClaimStatementPatientPaymentSource,
    Amount,
} from '@enter/core';

export interface IPaymentData extends ProviderPatientClaimStatementPatientPaymentSource {
    refundAmount?: Amount;
}

export const createPaymentsColumns = (): ITableColumn<IPaymentData>[] => [
    {
        id: 'paymentDate',
        Header: 'Payment date',
        accessor: 'paymentDate',
        Cell: ({ cell }): React.ReactElement => <div>{cell.value || ''}</div>,
    },
    {
        id: 'totalAmount',
        Header: 'Total amount',
        accessor: 'totalAmount',
        disableSortBy: true,
        Cell: ({ cell }): React.ReactElement => <div>{renderAmount(cell.value)}</div>,
    },
    {
        id: 'unallocatedAmount',
        Header: 'Unallocated amount',
        accessor: 'unallocatedAmount',
        disableSortBy: true,
        Cell: ({ cell }): React.ReactElement => <div>{renderAmount(cell.value)}</div>,
    },
    {
        id: 'allocatedAmount',
        Header: 'Allocated amount',
        accessor: 'allocatedAmount',
        disableSortBy: true,
        Cell: ({ cell }): React.ReactElement => <div>{renderAmount(cell.value)}</div>,
    },
    {
        id: 'refundAmount',
        Header: 'Refund amount',
        accessor: 'refundAmount',
        disableSortBy: true,
        Cell: ({ cell }): React.ReactElement => <div>{renderAmount(cell.value)}</div>,
    },
];

